import { useEffect, useState } from "react";
import "./github-markdown.css";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import Footer from "./Footer";

interface LegalPageProps {
  url: string;
}

function LegalPage(props: LegalPageProps) {
  return (
    <div>
      <div className="fixed top-0 w-full justify-around bg-background flex flex-col items-center">
        <Link to="/" className="p-1 m-2">
          <img src="images/logo_transparent.png" alt="logo" width="50" />
        </Link>
      </div>
      <LegalScreen {...props} />
      <Footer />
    </div>
  );
}

interface LegalServerResponse {
  title: string;
  body: string;
}

function LegalScreen({ url }: LegalPageProps) {
  const [text, setText] = useState("");

  useEffect(() => {
    const fetchPolicy = async () => {
      const policy = await fetch(url, { method: "POST" });
      const response = (await policy.json()) as LegalServerResponse;
      setText(response.body);
    };
    fetchPolicy().then(null);
  }, [url]);

  return (
    <div className="bg-background flex flex-col items-center justify-start">
      <div className="max-w-prose p-5 mt-20">
        <ReactMarkdown remarkPlugins={[remarkGfm]} className="markdown-body">
          {text}
        </ReactMarkdown>
      </div>
    </div>
  );
}

export function PrivacyPolicy() {
  return <LegalPage url="https://playguru.app:8000/legal/privacy-policy" />;
}

export function TermsOfService() {
  return <LegalPage url="https://playguru.app:8000/legal/terms-of-service" />;
}
